import { Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import APropos from './pages/APropos';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Atelier from './pages/Atelier';
import AtelierReservation from './pages/AtelierReservation';
import AtelierMerci from './pages/AtelierMerci';
import AtelierShortLink from './pages/AtelierShortLink';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';
import Reservation from './pages/Reservation';
import ReservationSuccess from './pages/ReservationSuccess';
import ReservationCancel from './pages/ReservationCancel';
import ReservationDevis from './pages/ReservationDevis';
import Avis from './pages/Avis';
import Offrir from './pages/Offrir';
import OffrirSuccess from './pages/OffrirSuccess';
import FAQ from './pages/FAQ';
import Universe from './pages/Universe';
import Noel from './pages/Noel';
import ConditionsGenerales from './pages/ConditionsGenerales';
import FichesLumiere from './pages/shop/FichesLumiere';
import FicheDetail from './pages/shop/FicheDetail';
import PdfOrder from './pages/shop/PdfOrder';

const publicPage = page => <Layout>{page}</Layout>;

// Shared by the browser and prerenderer; never import admin-only modules here.
export function publicRouteElements() {
  return <>
    <Route path="/" element={publicPage(<Home/>)} />
    <Route path="/a-propos" element={publicPage(<APropos/>)} />
    <Route path="/services" element={publicPage(<Services/>)} />
    <Route path="/univers/:universe" element={publicPage(<Universe/>)} />
    <Route path="/reserver-seance" element={publicPage(<Reservation sessionsOnly/>)} />
    <Route path="/reserver-seance/:serviceSlug" element={publicPage(<Reservation sessionsOnly/>)} />
    <Route path="/noel" element={publicPage(<Noel/>)} />
    <Route path="/bon-cadeau" element={publicPage(<Offrir giftLanding/>)} />
    <Route path="/portfolio" element={publicPage(<Portfolio/>)} />
    <Route path="/fiches-lumiere" element={publicPage(<FichesLumiere/>)} />
    <Route path="/pdf-commande/:id" element={publicPage(<PdfOrder/>)} />
    <Route path="/fiches-lumiere/pt" element={publicPage(<FichesLumiere/>)} />
    <Route path="/fiches-lumiere/pt/:id" element={publicPage(<FicheDetail/>)} />
    <Route path="/fiches-lumiere/:id" element={publicPage(<FicheDetail/>)} />
    <Route path="/contact" element={publicPage(<Contact/>)} />
    <Route path="/atelier" element={publicPage(<Atelier/>)} />
    <Route path="/atelier-lumiere/:slug" element={<AtelierShortLink/>} />
    <Route path="/atelier/reservation/:sessionId" element={publicPage(<AtelierReservation/>)} />
    <Route path="/atelier/merci/:reservationId" element={publicPage(<AtelierMerci/>)} />
    <Route path="/reservation" element={publicPage(<Reservation/>)} />
    <Route path="/r/:serviceSlug" element={publicPage(<Reservation/>)} />
    <Route path="/reservation/service/:serviceSlug" element={publicPage(<Reservation/>)} />
    <Route path="/reservation/success/:bookingId" element={publicPage(<ReservationSuccess/>)} />
    <Route path="/reservation/cancel/:bookingId" element={publicPage(<ReservationCancel/>)} />
    <Route path="/reservation/devis/:serviceSlug" element={publicPage(<ReservationDevis/>)} />
    <Route path="/faq" element={publicPage(<FAQ/>)} />
    <Route path="/avis" element={publicPage(<Avis/>)} />
    <Route path="/offrir" element={publicPage(<Offrir/>)} />
    <Route path="/offrir/:serviceSlug" element={publicPage(<Offrir/>)} />
    <Route path="/offrir/success/:giftId" element={publicPage(<OffrirSuccess/>)} />
    <Route path="/mentions-legales" element={publicPage(<MentionsLegales/>)} />
    <Route path="/conditions-generales" element={publicPage(<ConditionsGenerales/>)} />
    <Route path="/politique-confidentialite" element={publicPage(<Confidentialite/>)} />
    <Route path="*" element={<Navigate to="/" replace/>} />
  </>;
}